import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const userService = {
    /**
     * Upload profile picture
     * @param {File} file - The image file to upload
     * @returns {Promise} - API response with profile picture URL
     */
    uploadProfilePicture: async (file) => {
        try {
            const accessToken = localStorage.getItem('accessToken');

            if (!accessToken) {
                throw new Error('No authentication token found');
            }

            // Create FormData for file upload
            const formData = new FormData();
            formData.append('user_profile_picture', file);

            console.log('API Call - Upload profile picture');

            const response = await axios.post(
                `${API_BASE_URL}/user/profile-picture/upload/`,
                formData,
                {
                    headers: {
                        'Authorization': `Bearer ${accessToken}`,
                        'Content-Type': 'multipart/form-data',
                    },
                }
            );

            console.log('API Response - Profile picture upload success:', response.data);
            return response.data;
        } catch (error) {
            console.error('API Error - Profile picture upload failed:', {
                status: error.response?.status,
                data: error.response?.data,
                message: error.response?.data?.message || error.message
            });
            throw error;
        }
    },

    /**
     * Change user password
     * @param {string} currentPassword - The current password
     * @param {string} newPassword - The new password
     * @param {string} confirmPassword - The confirm password
     * @returns {Promise} - API response
     */
    changePassword: async (currentPassword, newPassword, confirmPassword) => {
        try {
            const accessToken = localStorage.getItem('accessToken');

            if (!accessToken) {
                throw new Error('No authentication token found');
            }

            console.log('API Call - Change password');

            // Create FormData for the request
            const formData = new FormData();
            formData.append('current_password', currentPassword);
            formData.append('new_password', newPassword);
            formData.append('confirm_password', confirmPassword);

            console.log('Request payload (FormData):', {
                current_password: currentPassword,
                new_password: newPassword,
                confirm_password: confirmPassword
            });
            console.log('API URL:', `${API_BASE_URL}/user/change-password/`);

            const response = await axios.post(
                `${API_BASE_URL}/user/change-password/`,
                formData,
                {
                    headers: {
                        'Authorization': `Bearer ${accessToken}`,
                        'Content-Type': 'multipart/form-data',
                    },
                }
            );

            console.log('API Response - Password change success:', response.data);
            return response.data;
        } catch (error) {
            console.error('API Error - Password change failed:', {
                status: error.response?.status,
                data: error.response?.data,
                message: error.response?.data?.message || error.message
            });
            throw error;
        }
    },

    /**
     * Verify OTP for password change
     * @param {string} otp - The OTP code
     * @returns {Promise} - API response
     */
    verifyPasswordChangeOTP: async (otp) => {
        try {
            const accessToken = localStorage.getItem('accessToken');

            if (!accessToken) {
                throw new Error('No authentication token found');
            }

            console.log('API Call - Verify password change OTP');

            // Create FormData for the request
            const formData = new FormData();
            formData.append('otp', otp);

            console.log('Request payload (FormData):', { otp });

            const response = await axios.post(
                `${API_BASE_URL}/user/change-password/`,
                formData,
                {
                    headers: {
                        'Authorization': `Bearer ${accessToken}`,
                        'Content-Type': 'multipart/form-data',
                    },
                }
            );

            console.log('API Response - OTP verification success:', response.data);
            return response.data;
        } catch (error) {
            console.error('API Error - OTP verification failed:', {
                status: error.response?.status,
                data: error.response?.data,
                message: error.response?.data?.message || error.message
            });
            throw error;
        }
    },
};
